module.exports = __webpack_public_path__ + "img/11.a3539c5b.png";